<template>
  <AdvertEmployerDetails
      v-if="currentPageParameters.emp_cand === 'emp' && index === firstFreeAgencyIndex"
  />
  <AgencyAdvert
      :user-type="currentPageParameters?.emp_cand"
      :agency="agency"
      @contactOpen="
          (event) => $emit('contactOpen', { form: event.form, type: event.type, social: event.social, agency })
        "
  />
  <AdvertCvLibrary
      v-if="currentPageParameters.emp_cand === 'cnd' && index === 2"
      :industry="currentIndustryName"
  />
</template>

<script>
import InputButton from 'Components/InputButton.vue';
import AgencyAdvert from "Components/AgencyAdvert.vue";
import AdvertCvLibrary from "Components/AdvertCvLibrary.vue";
import AdvertEmployerDetails from "Components/AdvertEmployerDetails.vue";

export default {
  name: 'SearchResultItem',
  components: { AdvertEmployerDetails, AdvertCvLibrary, AgencyAdvert, InputButton },
  props: {
    agency: {
      type: Object,
      default: () => ({}),
    },
    currentPageParameters: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
    },
    firstFreeAgencyIndex: {
      type: Number,
    },
    currentIndustryName: {
      type: String,
      default: '',
    },
  },
  emits: ["contactOpen"],
};
</script>
